'use client';

import { Button, Modal } from '@components/common';
import { useTranslation } from 'next-i18next';
import { CheckIcon } from '@heroicons/react/16/solid';

interface SearchpackConfirmationDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isConfirmLoading?: boolean;
}

export const SearchpackConfirmationDialog = (
  props: SearchpackConfirmationDialogProps,
) => {
  // Destructure props
  const {
    open, onConfirm, onCancel, isConfirmLoading,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  return (
    <Modal isOpen={open} onClose={onCancel} size="sm">
      <Modal.Header onClose={onCancel}>
        <h5 className="text-md">{t('my-jobs.card.actions.searchpack')}</h5>
      </Modal.Header>
      <Modal.Body>
        <p className="font-bold">
          {' '}
          {t('global.action.searchpack.details.included.benefits')}
        </p>
        <div className="my-5 flex items-center gap-5">
          <div className="border-r-2 border-gray-500/20 pr-5">
            <div className=" flex items-center gap-2">
              <CheckIcon className="size-5 text-secondary" />
              <span>{t('global.searchpack.benefit.2')}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckIcon className="size-5 text-secondary" />
              <span>{t('global.searchpack.benefit.1')}</span>
            </div>
          </div>

          <div className="font-bold">
            100 neuro
          </div>
        </div>
        <p>{t('global.action.searchpack.details')}</p>
      </Modal.Body>
      <Modal.Footer className="flex justify-end gap-2">
        <Button size="sm" onClick={onConfirm} color="secondary" isLoading={isConfirmLoading} disabled={isConfirmLoading}>
          {t('global.action.searchpack.activate')}
        </Button>
        <Button onClick={onCancel} color="light" size="sm">
          {t('global.action.cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
